// Import model
import { StartContactAskSyntheaRequest } from '../models/StartContactAskSyntheaRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartContactAskSyntheaRequest - handles JSON serialization and deserialization with type validation
 */
export class StartContactAskSyntheaRequestSerializer {
  /**
   * Deserializes a JSON string into a StartContactAskSyntheaRequest instance
   */
  static deserialize(json: string): StartContactAskSyntheaRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartContactAskSyntheaRequest instance
   */
  static fromObject(obj: any): StartContactAskSyntheaRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartContactAskSyntheaRequest');
    }


    const instance: StartContactAskSyntheaRequest = {
      assistantId: obj['AssistantId'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartContactAskSyntheaRequest instances
   */
  static deserializeArray(json: string): StartContactAskSyntheaRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartContactAskSyntheaRequest instance to a JSON string
   */
  static serialize(instance: StartContactAskSyntheaRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartContactAskSyntheaRequest instance to a plain object
   */
  static toObject(instance: StartContactAskSyntheaRequest): any {
    return {
      'AssistantId': instance.assistantId,
    };
  }

  /**
   * Serializes an array of StartContactAskSyntheaRequest instances to a JSON string
   */
  static serializeArray(instances: StartContactAskSyntheaRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
